import { useEffect, useRef } from 'react'

// * useMemorySafeTimeout * //
/**
 * ### useMemorySafeTimeout
 *
 * This hook returns a setTimout function that clears itself
 * when the component unmounts to avoid memory leaks
 */
export const useMemorySafeTimeout: () => (
  cb: () => void,
  ms: number
) => NodeJS.Timeout = () => {
  const timeoutId = useRef<NodeJS.Timeout>()

  const setSafeTimeout: (cb: () => void, ms: number) => NodeJS.Timeout = (
    cb,
    ms
  ) => {
    const id = setTimeout(() => {
      cb()
      timeoutId.current = undefined
    }, ms)
    timeoutId.current = id
    return id
  }

  useEffect(() => {
    return () => {
      if (!timeoutId) return
      clearTimeout(timeoutId.current)
    }
  }, [])

  return setSafeTimeout
}
